export default __webpack_public_path__ + "static/media/24 Track 24.ac5e3937.mp3";